import { useEffect, useRef } from "react";

/**
 * Adds the `on` class when the element enters the viewport (once). Drives the
 * self-drawing SVG strokes (`.landing-draw`) and any CSS keyed on `.on`.
 * Under prefers-reduced-motion the CSS renders the final state statically,
 * so firing the class is harmless either way.
 */
export function useDrawOnView<T extends HTMLElement>(threshold = 0.25) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);

  return ref;
}
